export const DOCUMENTS_DROPZONE_ACCEPTED_FILES = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'image/jpeg': ['.jpg'],
  'image/png': ['.png'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    '.pptx',
  ],
  'application/csv': ['.csv'],
  'text/csv': ['.csv'],
  'text/plain': ['.txt'],
};

export const LOCATIONS_DROPZONE_ACCEPTED_FILES = {
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
};

export const PROFILE_PICTURE_ACCEPTED_FILES = {
  'image/jpeg': ['.jpg'],
  'image/png': ['.png'],
};

export const SUBAUDIT_ACCEPTED_FILES = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.ms-excel': ['.xls'],
  'text/csv': ['.csv'],
};

export const TICKETS_ATTACHMENTS_DROPZONE_ACCEPTED_FILES = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/pdf': ['.pdf'],
  'text/csv': ['.csv'],
  'application/vnd.ms-excel': ['.xls'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'message/rfc822': ['.eml'],
  'application/vnd.ms-outlook': ['.msg'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
  'application/octet-stream': ['.wem'],
  'video/mp4': ['.mp4'],
  'audio/mpeg': ['.mp3'],
  'video/quicktime': ['.mov'],
};
const ONE_MB_BYTES = 1048576;
const ONE_GB_BYTES = 1024 * ONE_MB_BYTES;
export const DEFAULT_MAX_SIZE_MB = 100;

export const TICKET_MAX_SIZE_MB = 200;
export const TICKET_MAX_FILES_NUMBER = 10;
export const TICKET_ATTACHMENTS_ALLOWED_FORMATS =
  '.xlsx, .pdf, .csv, .xls, .jpeg, .png, .eml, .jpg, .msg, .xlsm, .wem, .mp4, .mov, .mp3';

export const TICKET_ATTACHMENTS_DROPZONE_MAX_SIZE_BYTES =
  TICKET_MAX_SIZE_MB * ONE_MB_BYTES;

export const DEFAULT_MAX_SIZE_BYTES = DEFAULT_MAX_SIZE_MB * ONE_MB_BYTES;

export const DOCUMENTS_MAX_SIZE_GB = 5;

export const DOCUMENTS_DROPZONE_MAX_SIZE_BYTES =
  DOCUMENTS_MAX_SIZE_GB * ONE_GB_BYTES;

export const DOCUMENTS_MAX_SIZE_PREVIEW_MB = 150;

export const DOCUMENTS_MAX_SIZE_PREVIEW_BYTES =
  DOCUMENTS_MAX_SIZE_PREVIEW_MB * ONE_MB_BYTES;

export const ACTION_ITEM_ATTACHMENTS_ALLOWED_FORMATS =
  '.pdf, .doc, .docx, .jpg, .xlsx, .pptx, .ppt, .csv, .txt';

export const PDF_EXTENSION = '.pdf';

// PROJECT FILES

export const PROJECT_FILES_MAX_SIZE_MB = 50;
export const PROJECT_FILES_DROPZONE_MAX_SIZE_BYTES =
  PROJECT_FILES_MAX_SIZE_MB * ONE_MB_BYTES * 100000000000;
// TODO: remove line above after testing

export const PROJECT_FILES_MAX_FILES_NUMBER = 50;
export const PROJECT_DROPZONE_ACCEPTED_FILES =
  DOCUMENTS_DROPZONE_ACCEPTED_FILES;
export const PROJECT_FILES_ALLOWED_FORMATS = Object.values(
  PROJECT_DROPZONE_ACCEPTED_FILES
)
  .flat()
  .join(', ');
